export const NoiseOverlay = () => {
  return (
    <>
      <div className="noise-overlay" aria-hidden="true" />
      <div className="concrete-overlay" aria-hidden="true" />
      <div className="scanline-overlay" aria-hidden="true" />
    </>
  );
};
